import { Injectable } from '@angular/core';
import { GeneralSelect } from '../_models/field';
import { LookUpResult } from '../_models/menu-options';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ListsHelperService {
  mapLookupResultToGeneralSelect(receivedResults: LookUpResult[], valuesAreNumeric: boolean, ignoreNA?: boolean): GeneralSelect[] {
    let receivedOptions: GeneralSelect[] = [];
    receivedOptions = receivedResults.map(result => {
      let option: GeneralSelect = {
        label: result.lookupValue,
        value: valuesAreNumeric ? +(result.entryValue) : result.entryValue
      };
      return option;
    });

    if (valuesAreNumeric) {
      receivedOptions.sort((a: any, b: any) => {
        let aValue = a.value;
        let bValue = b.value;
        if (aValue > bValue) {
          return 1;
        }
        if (bValue > aValue) {
          return -1;
        }
        return 0;
      })

      if (!ignoreNA) {
        receivedOptions.unshift(
          {
            label: 'N/A',
            value: null
          }
        );
      }
    }
    else {
      receivedOptions.sort((a: any, b: any) => {
        let aValue = a.value;
        let bValue = b.value;
        if (aValue > bValue) {
          return 1;
        }
        if (bValue > aValue) {
          return -1;
        }
        return 0;
      })

      if (!ignoreNA) {
        receivedOptions.unshift(
          {
            label: 'N/A',
            value: ''
          }
        );
      }
    }
    return receivedOptions;
  }

  sortProperty(property: string, reverseSort: boolean) {
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) {
        return 0;
      }

      let aValue = (typeof a[property] === 'string') ? a[property].toUpperCase() : a[property];
      let bValue = (typeof b[property] === 'string') ? b[property].toUpperCase() : b[property];

      if (aValue > bValue) {
        return reverseSort ? -1 : 1;
      }
      if (bValue > aValue) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortSubPropertyString(property: string, subProperty: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty]) {
        aValue = a[property][subProperty];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty]) {
        bValue = b[property][subProperty];
      }
      if (aValue.toLowerCase() > bValue.toLowerCase()) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.toLowerCase() > aValue.toLowerCase()) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  // Not converting values to lower case; in case the values are numbers
  sortSubProperty(property: string, subProperty: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty]) {
        aValue = a[property][subProperty];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty]) {
        bValue = b[property][subProperty];
      }
      if (aValue > bValue) {
        return reverseSort ? -1 : 1;
      }
      if (bValue > aValue) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortMultiSubPropertyString(property: string, subProperty1: any, subProperty2: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty1] && a[property][subProperty1][subProperty2]) {
        aValue = a[property][subProperty1][subProperty2];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty1] && b[property][subProperty1][subProperty2]) {
        bValue = b[property][subProperty1][subProperty2];
      }
      if (aValue.toLowerCase() > bValue.toLowerCase()) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.toLowerCase() > aValue.toLowerCase()) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortPropertyLength(property: string, reverseSort: boolean) {
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) {
        return 0;
      }

      let aValue: string = a[property];
      let bValue: string = b[property];
      if (aValue.length > bValue.length) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.length > aValue.length) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortPropertyDate(property: string, reverseSort: boolean) {
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) && !b.hasOwnProperty(property)) {
        return 0;
      }
      if (!a.hasOwnProperty(property) || a[property] == null) {
        return reverseSort ? 1 : -1;
      }
      if (!b.hasOwnProperty(property) || b[property] == null) {
        return reverseSort ? -1 : 1;
      }
      if (moment(a[property]).isAfter(moment(b[property]))) {
        return reverseSort ? -1 : 1;
      }
      if (moment(b[property]).isAfter(moment(a[property]))) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }
}
